import { HttpClient } from "./http/http-client";
import { ACCOUNTING_URL } from "../modules/accounting/services/invoices.service";
import { SETTINGS_URL, BILLING_URL } from "./common-urls";
export const INDEX_URL = '/index.pl';
export const AccountService = {
  findUserInfo: () => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'get_user_permissions',
  }),
  getV2InitData: () => HttpClient.get3(`/index.pl?section=init_v2`),

  updateClientNoticeDisplay: (client_notice_id) => {
    return HttpClient.get(INDEX_URL, {
      start:2,
      client_notice_id: client_notice_id,
      section:'init_v2'
    }
    );
  },
  payBill: ({
    action = 'pay',
  } = {}) => {
    return HttpClient.get(`${BILLING_URL}`, {
      action,
      output: 'json',
    })
  },
  payBillCredit: ({
    action = 'pay',
    payment_method = 'CREDITCARD',
    adyenEncryptedData = ''
  }) => {
    return HttpClient.post(`${BILLING_URL}`, {
      action,
      payment_method,
      'adyen-encrypted-data': adyenEncryptedData,
      output: 'json',
    })
  },
  payBillSEPA: ({
    action = 'pay',
    payment_method = 'SEPA',
    iban = '',
    ownerName = ''
  }) => {
    return HttpClient.post(`${BILLING_URL}`, {
      action,
      payment_method,
      iban,
      ownerName,
      output: 'json',
    })
  },
}


export const initData = () => {
  return {
    client: undefined,
    client_settings: undefined,
    default_permisson_items: undefined,
    display_notice_block: undefined,
    notices: undefined,
    paywall_block: undefined,
    shared_login_block: undefined,
    user: undefined,
  };
}

